import {Component, Input, Output, EventEmitter} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {PageButtonComponent} from '../buttons/page-button.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AppStateService} from '../../services/app-state.service';
import {CircleButtonComponent} from '../buttons/circle-button.component';
import {MenuItem} from '../../models/FSMenu';
import {AuthorizedApiService} from '../../services/authorized-api.service';
import {OrderService} from '../../services/order.service';
import {MenuUtils} from '../../utils/Utils';
import {TranslateService} from '../../services/translate.service';


@Component({
  standalone: true,
  imports: [CommonModule, ActionButtonComponent, PageButtonComponent, CircleButtonComponent],
  selector: 'app-menu-item',
  template: `
    <div class="flex mt-1 md:bg-theme-surface2-50 md:p-4 md:-m-3 md:rounded-xl md:min-h-40" (click)="add()">
      <div class="" [ngClass]="{'w-[calc(100%-3rem)]':!item.pic,'w-[calc(100%-6rem)]':item.pic}">
        <div *ngIf="readableWhen" class="text-theme-text-50 font-semi-bold"><i class="far fa-clock mr-1 text-sm"></i>{{readableWhen}}</div>
        <div class="text-xl/6 font-bold break-words">{{item.name}}</div>
        <div *ngIf="outOfStock" class="text-theme-notification2 font-medium text-xl">{{translate.getString("Slutsåld")}}</div>
        <div [class.text-theme-text3]="outOfStock" class="text-xl font-medium text-theme-text2 break-words tabular-nums flex items-center gap-2">
          <span class="inline-flex items-center gap-1.5"><i *ngIf="isTakeawayPrice(item)" class="fa-solid fa-person-carry-box text-base"></i>{{getPrice(item)}}</span>
          <span *ngIf="getTakeawayPrice(item) as tp" class="text-base bg-theme-surface2 rounded-xl px-2 inline-flex items-center gap-1"><i class="fa-solid fa-person-carry-box text-sm"></i>{{tp}}</span>
        </div>
        <div [class.text-theme-text3]="outOfStock" class="text-base/5 tracking-wide mt-1 overflow-y-hidden text-theme-text2 overflow-ellipsis line-clamp-3">{{item.desc}}</div>
      </div>
      <div *ngIf="item.pic" class="my-auto relative w-24">
        <img [src]="item.pic" class="w-24 h-24 object-cover rounded-lg" />
        <div class="absolute right-0 -bottom-6" *ngIf="!hidePlusThing">
          <ng-container *ngTemplateOutlet="plusThing"></ng-container>
        </div>
      </div>
      <div *ngIf="!item.pic && !hidePlusThing" class="my-auto pl-2 relative w-14">
        <ng-container *ngTemplateOutlet="plusThing"></ng-container>
      </div>
    </div>

    <ng-template #plusThing>
      <div>
        <app-circle-button [disabled]=outOfStock [icon]="'fa-plus'" size="12" type="solid" fontSize="lg" (onClick)="add()"></app-circle-button>
      </div>
      <div class="absolute -top-1 -right-1">
        <div *ngIf="count > 0" class="text-theme-notification2-text bg-theme-notification2 rounded-full w-6 h-6 flex justify-center items-center font-bold">{{count}}</div>
      </div>
    </ng-template>
  `
})
export class MenuItemComponent {
  @Input() count: number = 0;
  @Input() outOfStock: boolean = false;
  @Input() venueOpen: boolean = true;
  @Input() itemDisabled = false;
  @Input() showWhen = false;
  @Input() item!: MenuItem;
  @Input() hidePlusThing = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
  active = false;
  readableWhen?: string;

  constructor(private router: Router, private appStateService: AppStateService, private orderService: OrderService, protected translate: TranslateService) {}

  ngOnInit(): void {
    if (this.showWhen) {
      this.readableWhen = MenuUtils.readableWhenDeadline(this.item);
    }
  }

  getPrice(item: MenuItem): string {
    return this.orderService.getPriceForItem(item) || item.formatted;
  }

  getTakeawayPrice(item: MenuItem): string | null {
    return this.orderService.getTakeawayPriceForItem(item);
  }

  isTakeawayPrice(item: MenuItem): boolean {
    return this.orderService.isShowingTakeawayPrice(item);
  }

  add() {
    if (this.outOfStock || this.itemDisabled)
      return;
    console.log("Add item to order");
    this.onClick.emit();
  }

}
